// extracted by mini-css-extract-plugin
export default {"AddBtnWrap":"add-btn_AddBtnWrap__8v6-j"};